export default {
  alerts: (state) => state.alerts,
  newsItems: (state) => state.newsItems,
  circles: (state) => state.circles,
  doughnuts: (state) => state.doughnuts,
  computerEvolutionStats: (state) => state.computerEvolutionStats,
  alertEvolutionStats: (state) => state.alertEvolutionStats,
  vaccineEvolutionStats: (state) => state.vaccineEvolutionStats,
  agencyEvolutionStats: (state) => state.agencyEvolutionStats,
  alertsPerDayEvolutionStats: (state) => state.alertsPerDayEvolutionStats,
  agentsPerDayEvolutionStats: (state) => state.agentsPerDayEvolutionStats,
  alertsPerVaccineEvolutionStats: (state) => state.alertsPerVaccineEvolutionStats,
  loading: (state) => state.loading,
  isStatsEvolutionError: (state) => state.isStatsEvolutionError,
  pyramids: (state) => state.pyramids,
  totalAlerts: (state) => state.totalAlerts,
  lastAlertsLength: (state) => state.lastAlertsLength,
};
